/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CoverImageIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Cover Image',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="23.8" cy="12.6" r="2.5" />
    <path
      d="M34.875 4H1.125A1.068 1.068 0 0 0 0 5v22a1.068 1.068 0 0 0 1.125 1h2.4a13.248 13.248 0 0 1 3.24-1.088 11.565 11.565 0 0 1-2.131-6.469c0-.046.01-.086.01-.131C3.152 22.2 2 24 2 24V6h32v16a15.164 15.164 0 0 0-6.182-2c-2.463 0-4.647 2.785-7.019 3.7a11.691 11.691 0 0 1-1.55 3.242A13.647 13.647 0 0 1 22.383 28h12.492A1.068 1.068 0 0 0 36 27V5a1.068 1.068 0 0 0-1.125-1Z"
    />
    <path
      d="M24 34.038a3.12 3.12 0 0 0-1.048-2.353 10.109 10.109 0 0 0-5.738-2.234 1.144 1.144 0 0 1-.99-1.148v-1.658a1.114 1.114 0 0 1 .276-.721 8.747 8.747 0 0 0 2.007-5.481C18.507 16.31 16.315 14 13 14s-5.567 2.4-5.567 6.443a8.853 8.853 0 0 0 2.1 5.485 1.106 1.106 0 0 1 .273.717V28.3a1.138 1.138 0 0 1-.993 1.148 9.693 9.693 0 0 0-5.809 2.232A3.125 3.125 0 0 0 2 34v2h22Z"
    />
  </svg>`;
};
